import DashboardTitle from '@/agilis/components/Dashboard/DashboardTitle/DashboardTitle.vue'
import DashboardCounter from '@/agilis/components/Dashboard/DashboardCounter/DashboardCounter.vue'
import DashboardTable from '@/agilis/components/Dashboard/DashboardTable/DashboardTable.vue'
import DashboardChart from '@/agilis/components/Dashboard/DashboardChart/DashboardChart.vue'
import DashboardFilter from '@/agilis/components/Dashboard/DashboardFilter/DashboardFilter.vue'
import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import toursMixin from '@/agilis/components/Tour/mixins/toursMixin'

export default {
  name: 'Dashboard',
  mixins: [
    toursMixin
  ],
  props: {
    /**
     * The set of items returned by each queryId.
     * e.g.
     * {
     *   search: [{ id: 'item1' }, { id: 'item2' }],
     *   myQuery: [{ id: 'item3' }]
     * }
    */
    resultsSet: Object,
    /**
     * The context object for the dashboard component
    */
    context: Object,
    /**
     * A callback fuction that, given a dashboardMetric, returns the correct queryId
     * with a fallback to the "default" dashboardMetric query, if existing
    */
    queryId: Function,
    /**
     * A callback fuction that, given a dashboardMetric, returns the correct query configuration
     * with a fallback to the "default" dashboardMetric query, if existing
    */
    apiId: Function,
    queryConfiguration: Function,
    onFireQuery: Function
  },

  computed: {
    ...mapGetters({
      loading: 'loaderStore/loading'
    }),

    metrics () {
      return this.context?.dashboard?.metrics || {}
    },

    filters () {
      return this.context?.dashboard?.filters
    },

    layout () {
      const layout = this.context?.dashboard?.layout || []

      return layout
        .map((row) => {
          const cols = row.cols.filter((item) => {
            return this.userCanAccessMetric(item)
          })
          return cols.length > 0 ? { cols } : null
        })
        .filter(Boolean)
    },

    layoutElements () {
      return this.context?.dashboard?.layoutElements || {}
    }
  },

  components: {
    DashboardTitle,
    DashboardCounter,
    DashboardTable,
    DashboardChart,
    DashboardFilter
  },

  methods: {
    userCanAccessMetric (metric) {
      const privId = `${this.context.privilegeId}?metric=${metric}`
      return !Configuration.auth.userHasPrivilegeExclusion(privId)
    },

    cellSizeInLayout (colId, cellsInRow) {
      const cell = this.layoutElements[colId] || this.metrics[colId]

      return cell?.cols || (12 / (cellsInRow || 1))
    }
  }
}
